// BASE_URL configuration
// Production API URL: https://smartagroai.lk/api
// Development API URL: http://localhost:8080/api

const getBaseUrl = () => {
  // return 'https://smartagroai.lk/api';
  return 'https://digitalacademy.lk/api';
  // return 'http://localhost:8080/api';
};

const BASE_URL = getBaseUrl();

const BLOB_SAS_URL = 'https://digitalacademyblob.blob.core.windows.net/?sv=2022-11-02&ss=b&srt=sco&sp=rwdlaciytfx&se=2028-02-01T16:47:29Z&st=2024-04-15T08:47:29Z&spr=https&sig=PXflInl0xuyr2SdkW7bVShPgdvQ%2FKcf01pheAjYM41c%3D';

const USER_PROFILE_IMAGE_BLOB_BASE_URL = "https://digitalacademyblob.blob.core.windows.net/user-images/";

const DEFAULT_USER_PROFILE_IMAGE = 'https://digitalacademyblob.blob.core.windows.net/public/avatar.png';

const DEFAULT_COURSE_COVER_IMAGE = 'https://digitalacademyblob.blob.core.windows.net/public/courceImg.jpeg';

export {
    BASE_URL,
    BLOB_SAS_URL,
    USER_PROFILE_IMAGE_BLOB_BASE_URL,
    DEFAULT_USER_PROFILE_IMAGE,
    DEFAULT_COURSE_COVER_IMAGE,
}
